module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17Vnl1N/tc-custom/9781626810181.jpg?1704586003451",
      "alt": "This image is the cover for the book Naughty Talk"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Naughty Talk\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A handsome talk show host goes searching for the secrets of women’s deepest desires.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When Nicole Hart is bumped without notice from a guest spot on Anthony Gawain’s provocative talk show, she is plenty steamed. She decides to get even on camera by pretending to be a sex therapist to address the question posed on his next show: "), _c('i', [_vm._v("What Do Women Want?")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" As sparks fly between Nicole and the handsome host, it soon becomes clear neither one of them can even remember the question. But to Nicole’s surprise, Anthony might have some answers that she wasn’t expecting . . ."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tiffany White\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0